export const StockBalanceTypes = {
  ASSET: 'answer_balance_asset',
  CASH: 'answer_balance_cash',
  INSURANCE: 'answer_balance_insurance',
  BANKRUPT: 'answer_balance_bankrupt'
};
